import {
  CreatePageFormSchemaType,
  TranscriptsFilterTypesEnum,
} from '../../../../../../page-creation-flow/config/types';
import { useController, useFormContext } from 'react-hook-form';
import { FathomCallerNameSelect } from './FathomCallerNameSelect';
import { Select } from '../../../../../../../shared/ui';
import { transcriptsFilterList } from './config';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { fathomModel } from '../../../../../../../entities/fathom';
import { FathomTranscriptsPicker } from './FathomTranscriptsPicker';

export const FathomTranscriptsSelect = () => {
  const {
    formState: { errors },
    control,
  } = useFormContext<CreatePageFormSchemaType>();

  const {
    field: { value: selectedFathomCallerName },
  } = useController({
    control,
    name: 'selectedFathomCallerName',
    rules: { required: true },
  });

  const {
    field: {
      value: selectedTranscriptsFilter,
      onChange: handleChangeTranscriptsFilter,
    },
  } = useController({
    control,
    name: 'transcriptsFilter',
    rules: { required: true },
  });

  const {
    field: { value: selectedTranscripts, onChange: setSelectedTranscripts },
  } = useController({
    control,
    name: 'selectedFathomTranscripts',
    rules: { required: true },
  });

  const transcripts = useSelector(fathomModel.selectors.selectTranscripts);

  const filteredTranscriptsByName = useMemo(
    () =>
      transcripts?.filter(
        (el) => !!el.participants.find((el) => el === selectedFathomCallerName)
      ),
    [transcripts, selectedFathomCallerName]
  );

  const toggleCallTranscript = (transcriptId: string) => {
    const index = selectedTranscripts.indexOf(transcriptId);
    if (index !== -1) {
      setSelectedTranscripts(
        selectedTranscripts.filter((id) => id !== transcriptId)
      );
    } else {
      setSelectedTranscripts([...selectedTranscripts, transcriptId]);
    }
  };

  const toggleAllTranscripts = () => {
    if (selectedTranscripts.length === filteredTranscriptsByName?.length) {
      setSelectedTranscripts([]);
    } else {
      setSelectedTranscripts(filteredTranscriptsByName?.map((el) => el.id));
    }
  };

  return (
    <div>
      <FathomCallerNameSelect isError={!!errors.selectedFathomCallerName} />
      {selectedFathomCallerName && !!transcripts.length && (
        <div className="flex items-start gap-3 whitespace-nowrap my-3">
          <p className="text-gray-700 mt-2.5">Call transcript(s)</p>
          <div className="w-full">
            <Select
              label=""
              onChange={handleChangeTranscriptsFilter}
              items={transcriptsFilterList}
              value={selectedTranscriptsFilter}
              currentValue={transcriptsFilterList.find(
                (type) => selectedTranscriptsFilter === type.id
              )}
              error={errors.transcriptsFilter?.message}
              errorMsg={errors.transcriptsFilter?.message}
              listStyles="max-h-60 !gap-y-0.5 !p-1.5"
              listItemStyles="h-9.5 pl-2.5"
              className="!h-11"
              buttonStyles="!h-11"
              hideLabel
            />
          </div>
        </div>
      )}
      {filteredTranscriptsByName &&
        selectedFathomCallerName &&
        selectedTranscriptsFilter === TranscriptsFilterTypesEnum.SPECIFIC && (
          <FathomTranscriptsPicker
            transcripts={filteredTranscriptsByName}
            selectedTranscripts={selectedTranscripts}
            toggleCallTranscript={toggleCallTranscript}
            toggleAllTranscripts={toggleAllTranscripts}
            isError={!!errors.selectedTranscripts}
            messageText={errors.selectedTranscripts?.message}
          />
        )}
    </div>
  );
};
